import produce from "immer";
import {
  normalizeFullCircleList,
  parseFolderGroupedResponse,
} from "./normalizeList";
import {
  GET_FULL_CIRCLE_LIST,
  GET_FULL_CIRCLE_LIST_SUCCESS,
  GET_FULL_CIRCLE_LIST_ERROR,
  SET_FULL_CIRCLE_PAGE,
  ADD_FULL_CIRCLE,
  ADD_FULL_CIRCLE_SUCCESS,
  ADD_FULL_CIRCLE_ERROR,
  EDIT_FULL_CIRCLE,
  EDIT_FULL_CIRCLE_SUCCESS,
  EDIT_FULL_CIRCLE_ERROR,
  DELETE_FULL_CIRCLE,
  DELETE_FULL_CIRCLE_SUCCESS,
  DELETE_FULL_CIRCLE_ERROR,
  SCHEDULE_CALL,
  SCHEDULE_CALL_SUCCESS,
  SCHEDULE_CALL_ERROR,
  GET_INTERVIEW_FOLDERS,
  GET_INTERVIEW_FOLDERS_SUCCESS,
  GET_INTERVIEW_FOLDERS_ERROR,
  ADD_INTERVIEW_FOLDER,
  ADD_INTERVIEW_FOLDER_SUCCESS,
  ADD_INTERVIEW_FOLDER_ERROR,
  EDIT_INTERVIEW_FOLDER,
  EDIT_INTERVIEW_FOLDER_SUCCESS,
  EDIT_INTERVIEW_FOLDER_ERROR,
  DELETE_INTERVIEW_FOLDER,
  DELETE_INTERVIEW_FOLDER_SUCCESS,
  DELETE_INTERVIEW_FOLDER_ERROR,
  SET_INTERVIEW_FOLDERS,
  SET_FULL_CIRCLE_LIST,
} from "./actionTypes";

const initialState = {
  fullCircleList: [],
  interviewFolders: [],
  foldersLoading: false,
  folderActionLoading: false,
  loading: false,
  addLoading: false,
  editLoading: false,
  deleteLoading: false,
  error: "",
  totalCount: 0,
  totalPages: 1,
  page: 1,
  pageSize: 20,
};

const fullCircleReducer = produce((state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_FULL_CIRCLE_LIST:
      return { ...state, loading: true };

    case GET_FULL_CIRCLE_LIST_SUCCESS: {
      const requestType = payload._requestType;
      const grouped = parseFolderGroupedResponse(payload, requestType);

      return {
        ...state,
        fullCircleList: grouped?.items ?? normalizeFullCircleList(payload, requestType),
        totalCount: payload.meta?.totalCount ?? 0,
        totalPages: payload.meta?.totalPages ?? 1,
        page: payload.meta?.page ?? 1,
        pageSize: payload.meta?.limit ?? 20,
        loading: false,
      };
    }

    case GET_FULL_CIRCLE_LIST_ERROR:
      return { ...state, error: payload, loading: false };

    case SET_FULL_CIRCLE_PAGE:
      return { ...state, page: payload };

    case ADD_FULL_CIRCLE:
      return { ...state, addLoading: true };
    case ADD_FULL_CIRCLE_SUCCESS:
      return { ...state, addLoading: false };
    case ADD_FULL_CIRCLE_ERROR:
      return { ...state, addLoading: false };

    case EDIT_FULL_CIRCLE:
      return { ...state, editLoading: true };
    case EDIT_FULL_CIRCLE_SUCCESS:
      return { ...state, editLoading: false };
    case EDIT_FULL_CIRCLE_ERROR:
      return { ...state, editLoading: false };

    case DELETE_FULL_CIRCLE:
      return { ...state, deleteLoading: true };
    case DELETE_FULL_CIRCLE_SUCCESS:
      return { ...state, deleteLoading: false };
    case DELETE_FULL_CIRCLE_ERROR:
      return { ...state, deleteLoading: false };

    case SCHEDULE_CALL:
      return { ...state, addLoading: true };
    case SCHEDULE_CALL_SUCCESS:
      return { ...state, addLoading: false };
    case SCHEDULE_CALL_ERROR:
      return { ...state, addLoading: false };

    case GET_INTERVIEW_FOLDERS:
      return { ...state, foldersLoading: true };
    case GET_INTERVIEW_FOLDERS_SUCCESS:
      return {
        ...state,
        interviewFolders: Array.isArray(payload) ? payload : [],
        foldersLoading: false,
      };
    case GET_INTERVIEW_FOLDERS_ERROR:
      return { ...state, foldersLoading: false };

    case ADD_INTERVIEW_FOLDER:
    case EDIT_INTERVIEW_FOLDER:
    case DELETE_INTERVIEW_FOLDER:
      return { ...state, folderActionLoading: true };
    case ADD_INTERVIEW_FOLDER_SUCCESS:
    case EDIT_INTERVIEW_FOLDER_SUCCESS:
    case DELETE_INTERVIEW_FOLDER_SUCCESS:
      return { ...state, folderActionLoading: false };
    case ADD_INTERVIEW_FOLDER_ERROR:
    case EDIT_INTERVIEW_FOLDER_ERROR:
    case DELETE_INTERVIEW_FOLDER_ERROR:
      return { ...state, folderActionLoading: false };

    case SET_INTERVIEW_FOLDERS:
      return { ...state, interviewFolders: payload };

    case SET_FULL_CIRCLE_LIST:
      return {
        ...state,
        fullCircleList: Array.isArray(payload) ? payload : [],
      };

    default:
      return state;
  }
});

export default fullCircleReducer;
